import { PERMISSIONS, rolesWithPermission } from '@/auth/permissions'

export default [
  {
    header: 'General',
  },
  {
    title: 'Dashboard',
    route: 'dashboard-ecommerce',
    icon: 'HomeIcon',
    role: rolesWithPermission(PERMISSIONS.VIEW_DASHBOARD),
  },
  {
    header: 'Master Data',
  },
  {
    title: 'User',
    route: 'apps-users-list',
    icon: 'UserIcon',
    role: rolesWithPermission(PERMISSIONS.VIEW_USERS),
  },
  {
    title: 'Branch',
    route: 'apps-branches-list',
    icon: 'ArchiveIcon',
    role: rolesWithPermission(PERMISSIONS.VIEW_BRANCHES),
  },
  {
    title: 'Role',
    route: 'apps-roles-list',
    icon: 'ShieldIcon',
    role: rolesWithPermission(PERMISSIONS.VIEW_ROLES),
  },
  {
    title: 'Roles & Permissions',
    route: 'apps-roles-permissions',
    icon: 'LockIcon',
    role: rolesWithPermission(PERMISSIONS.VIEW_ROLES),
  },
  {
    header: 'Documents',
  },
  {
    title: 'Contracts',
    route: 'apps-contracts-list',
    icon: 'FileIcon',
    role: rolesWithPermission(PERMISSIONS.VIEW_CONTRACTS),
  },
  {
    title: 'Certificate',
    route: 'apps-certificates-list',
    icon: 'AwardIcon',
    role: rolesWithPermission(PERMISSIONS.VIEW_CERTIFICATES),
  },
  {
    title: 'Receipt',
    route: 'apps-receipts-list',
    icon: 'FileTextIcon',
    role: rolesWithPermission(PERMISSIONS.VIEW_RECEIPTS),
  },
  {
    title: 'Invoice',
    icon: 'FileTextIcon',
    role: rolesWithPermission(PERMISSIONS.VIEW_INVOICES),
    children: [
      {
        title: 'Internal',
        route: 'apps-invoices-internal',
        role: rolesWithPermission(PERMISSIONS.VIEW_INVOICES),
      },
      {
        title: 'Local',
        route: 'apps-invoices-local',
        role: rolesWithPermission(PERMISSIONS.VIEW_INVOICES),
      },
      {
        title: 'Corporate',
        route: 'apps-invoices-corporate',
        role: rolesWithPermission(PERMISSIONS.VIEW_INVOICES),
      },
      {
        title: 'Void',
        route: 'apps-invoices-void',
        role: rolesWithPermission(PERMISSIONS.VIEW_INVOICES),
      },
    ],
  },
  {
    title: 'Void Invoice',
    route: 'apps-void',
    icon: 'XCircleIcon',
    role: rolesWithPermission(PERMISSIONS.VOID_INVOICES),
  },
  {
    title: 'Job Register',
    route: 'apps-jobregister-list',
    icon: 'ClipboardIcon',
    role: rolesWithPermission(PERMISSIONS.VIEW_JOBS),
  },
  {
    title: 'Lab Samples',
    route: 'apps-labsamples',
    icon: 'ActivityIcon',
    role: rolesWithPermission(PERMISSIONS.VIEW_PROGRESS),
  },
  {
    header: 'Reports',
  },
  {
    title: 'Invoice & Job Report',
    route: 'apps-reports-overview',
    icon: 'BarChart2Icon',
    role: rolesWithPermission(PERMISSIONS.VIEW_REPORTS),
  },
  {
    title: 'Income',
    icon: 'DollarSignIcon',
    role: rolesWithPermission(PERMISSIONS.VIEW_INCOME),
    children: [
      {
        title: 'External (All)',
        route: 'apps-income-external-all',
        role: rolesWithPermission(PERMISSIONS.VIEW_INCOME),
      },
      {
        title: 'Corporate',
        route: 'apps-income-corporate',
        role: rolesWithPermission(PERMISSIONS.VIEW_INCOME),
      },
      {
        title: 'Local',
        route: 'apps-income-local',
        role: rolesWithPermission(PERMISSIONS.VIEW_INCOME),
      },
      {
        title: 'Internal',
        route: 'apps-income-internal',
        role: rolesWithPermission(PERMISSIONS.VIEW_INCOME),
      },
      {
        title: 'External (Nett)',
        route: 'apps-income-external-nett',
        role: rolesWithPermission(PERMISSIONS.VIEW_INCOME),
      },
    ],
  },
  {
    header: 'Administration',
  },
  {
    title: 'Settings',
    route: 'apps-settings',
    icon: 'SettingsIcon',
    role: rolesWithPermission(PERMISSIONS.VIEW_SETTINGS),
  },
]
